export default "__VITE_ASSET__fbrWVcID__"